declare global {
  interface Window {
    _hsq: any[]
    HubSpotConversations?: {
      widget: {
        open: () => void
      }
    }
  }
}

export function openChat(): boolean {
  const widget = window.HubSpotConversations?.widget
  if (!widget) return false

  widget.open()
  return true
}

export default function load() {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = '//js.hs-scripts.com/8542722.js'
  script.id = 'hs-script-loader'

  document.head.appendChild(script)

  const _hsq = (window._hsq = window._hsq || [])
  _hsq.push(['setPath', '/'])
  _hsq.push(['trackPageView'])
}

export function identify(email: string, extraProperties = {}) {
  const isHubspotInstalled = !!window._hsq
  if (!isHubspotInstalled) return
  const props = {
    email,
    ...extraProperties
  }
  window._hsq.push(['identify', props])
}
